import React from 'react';
import { REDUCER_NAME as COMMON_REDUCER_NAME } from '../../../app/commonReducer';
import { withComponentId } from '../../../common/ComponentIdContext';
import { withComponentName } from '../../../common/ComponentNameContext';
import { TYPE_DISABLE } from '../../../common/sync-component/Const';
import EventEmitter, {
  SYNC_COMPONENT_SEARCH,
} from '../../../helpers/EventEmitter';
import {
  changeTableIndexSortState,
  REDUCER_NAME,
  setSortedIds,
  toggleConfirmPopupDelete,
} from '../reducer';
import { connect } from 'react-redux';
import Table from '../../../common/table/Table';
import Const from './Const';
import { includes } from 'lodash';
import { getColorRedGreen } from '../../../helpers/Color';
import { formatPrice, formatTextFloat } from '../../../helpers/Text';
import TextBlink from '../../../common/table/TextBlink';
import CellHover from '../summary/CellHover';
import './table.scss';
import {
  getDataFollowKeyByDot,
  syncComponentSelector,
} from '../../../helpers/Common';
import TradingViewUrl from '../../../common/TradingViewUrl';
import { compose } from 'redux';

const getDataFromRedux = state => state[REDUCER_NAME].listSummaryTableByTicker;

class TablePerformance extends React.Component {
  handleDelete = (isShow, organCode) => () => {
    const { toggleConfirmPopupDelete } = this.props;

    toggleConfirmPopupDelete(isShow, organCode);
  };

  onRowClick = organCode => {
    const { listOrganizationByOrganCode, syncType } = this.props;
    if (syncType === TYPE_DISABLE) {
      return;
    }
    EventEmitter.dispatch(SYNC_COMPONENT_SEARCH, {
      syncType: syncType,
      search: listOrganizationByOrganCode[organCode],
    });
  };

  render() {
    const {
      ids,
      isFetching,
      idHover,
      isShowDeleteIcon,
      changeTableIndexSortState,
      sortState,
      setSortedIds,
    } = this.props;

    return (
      <div className="watchlist-performance-wrap d-flex flex-fill px-20 mb-10">
        <Table
          clickRow={this.onRowClick}
          onRowReorder={setSortedIds}
          ids={ids}
          sortState={sortState}
          onSort={changeTableIndexSortState}
          resizable={true}
          columnDraggable={true}
          rowDraggable={true}
          hideColumns={[]}
          isLoading={isFetching}
          getDataFromRedux={getDataFromRedux}
          idHover={idHover}
          schema={Object.keys(Const.listColumn).map((item2, index) => {
            const key = Const.listColumn[item2];
            const title = `watchListPerformance.listTitleTable.${item2}`;
            const result = {
              key,
              title,
            };

            if (index === 0) {
              return {
                ...result,
                isString: true,
                render: (text, item) => (
                  <CellHover
                    organCode={item.organCode}
                    isShowDeleteIcon={isShowDeleteIcon}
                    handleDelete={this.handleDelete(
                      true,
                      getDataFollowKeyByDot(item, Const.ORGAN_CODE),
                    )}
                  >
                    <div className="pl-10">
                      <TradingViewUrl code={item.organCode} />
                      &nbsp;{text}
                    </div>
                  </CellHover>
                ),
              };
            }

            if (includes([Const.listColumn.MATCH_PRICE], key)) {
              return {
                ...result,
                render: (text, item) => {
                  return (
                    <TextBlink
                      item={item}
                      tradingDate={Const.listIgnoreColumn.TRADING_DATE}
                    >
                      {formatTextFloat(formatPrice(text))}
                    </TextBlink>
                  );
                },
              };
            }

            return {
              ...result,
              render: (text, item) => {
                const className = getColorRedGreen(text, 'text');
                return (
                  <TextBlink
                    item={item}
                    tradingDate={Const.listIgnoreColumn.TRADING_DATE}
                    className={className}
                  >
                    {formatTextFloat(text * 100) + ' %'}
                  </TextBlink>
                );
              },
            };
          })}
        />
      </div>
    );
  }
}

const mapStateToProps = (state, { componentName, componentId }) => ({
  ids:
    state[REDUCER_NAME].sortedIds || state[REDUCER_NAME].listTickerSummaryTable,
  isFetching: state[REDUCER_NAME].isFetching,
  idHover: state[REDUCER_NAME].organCodeHover,
  sortState: state[REDUCER_NAME].tableIndexSortState,
  listOrganizationByOrganCode:
    state[COMMON_REDUCER_NAME].listOrganizationByOrganCode,
  syncType: syncComponentSelector(state, componentName, componentId),
});
const mapDispatchToProps = {
  toggleConfirmPopupDelete,
  changeTableIndexSortState,
  setSortedIds,
};

export default compose(
  withComponentName,
  withComponentId,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
)(TablePerformance);
